<template>
  <div class="form">
    <div class="form__name">Форма обратной связи</div>
    <form @submit="mailSend" v-if="!sendSuccess">
      <div class="form__block">
        <div class="form__single">
          <input type="text" title="Ваше имя" id="form-name" class="form__input" :class="{'error':formActive && !formName.length, 'active':this.formName.length}" v-model="formName">
          <label for="form-name" class="form__label">Ваше имя *</label>
        </div>
        <div class="form__single">
          <input type="tel" title="Ваш номер телефона" id="form-phone" class="form__input" :class="{'error':formActive && !validPhone(), 'active':this.formPhone.length}" v-model="formPhone" v-mask="'+7 (###) ###-##-##'">
          <label for="form-phone" class="form__label">Номер телефона</label>
        </div>
        <div class="form__single">
          <input type="text" title="Ваш e-mail" id="form-mail" class="form__input" :class="{'error':formActive && !validEmail(), 'active':this.formEmail.length}" v-model="formEmail">
          <label for="form-mail" class="form__label">Ваш e-mail *</label>
        </div>
        <div class="form__twin">
          <textarea title="Текст сообщения" id="form-text" class="form__textarea" :class="{'error':formActive && !formText.length, 'active':this.formText.length}" v-model="formText"></textarea>
          <label for="form-text" class="form__label">Текст сообщения *</label>
        </div>
        <div class="form__twin center">
          <div class="form__footnote">Поля со * обязательны к заполнению</div>
          <div class="form__recaptcha">
            <vue-recaptcha class="form__recaptcha-input"
                           ref="recaptcha"
                           @verify="recaptchaVerify"
                           @expired="recaptchaExpired"
                           :sitekey="sitekey">
            </vue-recaptcha>
          </div>
          <div class="form__error" v-if="arrayErrors && arrayErrors.length">
            <span class="form__error-row" v-for="(error, indexErrors) in arrayErrors" :key="indexErrors">{{error}}</span>
          </div>
          <button title="Уже отправляется" class="form__submit" :class="{'disabled':progressSubmit}" type="submit"><img src="../assets/loader.gif" alt="" class="form__submit-loader" v-if="progressSubmit">Отправить</button>
        </div>
      </div>
    </form>
    <div class="form__success" v-else>
      Ваше письмо успешно отправлено
    </div>
    <div class="form__ad">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="47.86" viewBox="0 0 48 47.86" class="form__ad-svg">
        <path class="a" d="M21.26.15a24,24,0,0,0,0,47.7A2.43,2.43,0,0,0,24,45.44v-.16a2.45,2.45,0,0,0-2.21-2.41A19,19,0,1,1,43,24v3.47a3.51,3.51,0,0,1-4.24,3.43A3.58,3.58,0,0,1,36,27.37V14.5a2.49,2.49,0,0,0-5-.22,12,12,0,1,0,1.61,18A8.37,8.37,0,0,0,38.92,36,8.51,8.51,0,0,0,48,27.47V24A24,24,0,0,0,21.26.15ZM24,31a7,7,0,1,1,7-7A7,7,0,0,1,24,31Z"/>
      </svg>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'
import utils from '../js/utils'

export default {
  name: "FormContacts",
  components: { VueRecaptcha },
  data () {
    return {
      sitekey: '6LcJFMcZAAAAAFLszzykoP3fhzePWaA4pgkJ0UNp',
      formActive: false,
      formName: '',
      formPhone: '',
      formEmail: '',
      formText: '',
      results: [],
      progressSubmit: false,
      arrayErrors: [],
      sendSuccess: false,
      verify: ''
    }
  },
  watch: {
    formPhone (newCount, oldCount) {
      if (Math.abs(newCount.length - oldCount.length) > 4) {
        this.value = '';
        setTimeout(() => {
          this.value = newCount;
          console.log('rewrite');
        }, 1000);
      }
    }
  },
  methods: {
    formAPI: function () {
      axios.post('/api/contact_form.php', {
        user_name: this.formName,
        user_phone: this.formPhone,
        user_mail: this.formEmail,
        text: this.formText,
        captcha: this.verify
      }).then((response) => {
        this.resetRecaptcha()
        this.results = response.data
        if (this.results.status) {
          this.sendSuccess = true

        } else {
          this.arrayErrors = this.results.errors
          this.progressSubmit = false
        }
      }).catch(() => {
        this.resetRecaptcha()
        this.arrayErrors.push('Возникла ошибка при отправке письма. Попробуйте отправить письмо позже.')
        this.progressSubmit = false
      })
    },
    mailSend (e) {
      this.formActive = true
      e.preventDefault()
      if (!this.progressSubmit) {
        this.progressSubmit = true
        return this.validName() && this.validPhone() && this.validEmail() && this.validText() ? this.formAPI() : this.progressSubmit = false
      }
    },
    validName () {
      return this.formName.length
    },
    validPhone () {
      return !this.formPhone.length || utils.validatePhone(this.formPhone)
    },
    validEmail () {
      return this.formEmail.length && utils.validateEmail(this.formEmail)
    },
    validText () {
      return this.formText.length
    },
    jsRecaptchaCreate () {
      const $script = document.createElement('script')
      $script.async = true
      $script.src = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit'
      document.head.appendChild($script)
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset()
    },
    recaptchaExpired () {
      this.resetRecaptcha()
    },
    recaptchaVerify: function (response) {
      this.verify = response
    }
  },
  mounted () {
    this.jsRecaptchaCreate()
  }
}
</script>

<style lang="scss" scoped>
  .form {
    position: relative;
    margin: 30px -10px 0;
    padding: 15px 0;
    border-top: 1px solid $color-link;
    text-align: center;

    @media screen and (min-width: 768px){
      margin: 30px 0 0;
      padding: 25px 0;
      border: 1px solid $color-link;
      border-radius: 5px;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      border: 26px solid transparent;
      border-left: 26px solid $color-link;
      border-top: 26px solid $color-link;

      @media screen and (min-width: 768px){
        border: 39px solid transparent;
        border-left: 39px solid $color-link;
        border-top: 39px solid $color-link;
      }
    }

    &__ad {
      position: absolute;
      z-index: 2;
      left: 4px;
      top: 4px;
      width: 22px;
      height: 22px;

      @media screen and (min-width: 768px){
        left: 8px;
        top: 7px;
        width: 30px;
        height: 30px;
      }

      &-svg {
        width: 100%;
        height: auto;
        vertical-align: bottom;
        fill: #ffffff;
      }
    }

    &__name {
      font-family: Roboto-Bold, sans-serif;
      @include font(14px, 18px, $color-dark-gray);
      text-transform: uppercase;
      text-align: center;

      @media screen and (min-width: 768px){
        @include font(16px, 20px, $color-dark-gray);
      }
    }

    &__warning {
      display: inline-block;
      margin: -15px 0 0;
      padding: 5px 15px;
      text-align: center;
      background: $color-error;
      @include font(14px, 17px, #ffffff);

      @media screen and (min-width: 768px){
        display: block;
      }
    }

    &__success {
      display: inline-block;
      margin: 50px auto;
      padding: 5px 15px;
      text-align: center;
      background: $color-success;
      @include font(14px, 17px, #ffffff);

      @media screen and (min-width: 768px){
        display: block;
        margin: 50px auto;
        width: 650px;
      }
    }

    &__error {
      margin: 25px 0 10px;

      &-row {
        display: block;
        @include font(14px, 17px, $color-error-text);

        & + & {
          margin: 7px 0 0;
        }
      }
    }

    &__block {
      position: relative;
      margin: 25px 10px 0;
      text-align: left;

      @media screen and (min-width: 768px){
        width: 650px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 30px 20px;
        margin: 35px auto 0;
      }
    }

    &__single, &__twin {
      position: relative;
      margin: 25px 0 0;


      @media screen and (min-width: 768px){
        margin: 0;
      }

      &.center {
        text-align: center;
      }
    }

    &__single {
      @media screen and (min-width: 768px){
        grid-column: 1/0;
      }
    }

    &__twin {
      @media screen and (min-width: 768px){
        grid-column: 1/4;
      }
    }

    &__input, &__textarea {
      position: relative;
      z-index: 1;
      display: block;
      width: 100%;
      border: 1px solid $color-link;
      @include font(12px, 16px, $color-dark-gray);
      border-radius: 5px;

      @media screen and (min-width: 768px){
        @include font(14px, 18px, $color-dark-gray);
      }

      &.error {
        border-color: $color-error;
      }
    }

    &__input {
      height: 40px;
      padding: 0 10px;
    }

    &__textarea {
      padding: 10px;
      height: 100px;
      resize: none;

      @media screen and (min-width: 768px){
        height: 150px;
      }
    }

    &__label {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      padding: 0 10px;
      @include font(14px, 40px, $color-gray);
      transition: all linear .3s;

      :focus + &, .active + & {
        top: -15px;
        left: 5px;
        width: auto;
        height: auto;
        padding: 1px 5px;
        background: #ffffff;
        @include font(12px, 12px, $color-dark-gray);

        @media screen and (min-width: 768px){
          top: -17px;
          @include font(14px, 14px, $color-dark-gray);
        }
      }

      .error + & {
        color: $color-error;
      }
    }

    &__submit {
      display: inline-block;
      margin: 20px auto 0;
      width: 150px;
      height: 40px;
      border: 0;
      border-radius: 5px;
      background: $color-link;
      @include font(14px, 40px, #ffffff);
      text-transform: uppercase;
      cursor: pointer;
      transition: linear .3s;

      &:hover {
        background: $color-link-hover;
      }

      &.disabled {
        background: #ffffff;
        cursor: default;
        font-size: 0;
        border: 1px solid $color-link-hover;
        transition: none;
      }

      &-loader {
        height: 36px;
        vertical-align: top;
      }
    }

    &__footnote {
      margin: -10px 0 0;
      @include font(12px, 16px, $color-gray);

      @media screen and (min-width: 768px){
        margin: -20px 0 0;
        @include font(13px, 18px, $color-gray);
      }
    }
  }
</style>

<style lang="scss">
  .form__recaptcha {
    position: relative;
    margin: 20px 0 0;
    text-align: center;

    &-input {
      display: inline-block;
    }
  }
</style>